import type { Asserts } from 'yup';

import { contractSchema as nutzContractSchema } from '@/features/Sparten/nutzv2/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = nutzContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useNutzv2ContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'Nutzv2ContractStore',
);
